// extracted by mini-css-extract-plugin
export default {"container":"qL-z","dimension":"rL-z","dimensionLabels":"sL-z"};